import { render, staticRenderFns } from "./ReminderType.vue?vue&type=template&id=098e0726&"
import script from "./ReminderType.vue?vue&type=script&lang=js&"
export * from "./ReminderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports